import React from 'react'
import Toast from './Toast'
import { render } from 'react-dom'
import { ERROR, INFO, SUCCESS, WARNING } from './constant'

const getToastsContainer = () => {
  const toastsContainer = document.querySelectorAll('[apex-toasts-container]')
  //if toastContainer is not in DOM, create one and return it.
  if (!toastsContainer?.[0]) {
    const containerElement = document.createElement('div')
    //Container needs to have the absolute positioning for toasts to always display on top right
    // z-index 2300 is to beatout the modal z-index of 1300
    containerElement.setAttribute(
      'style',
      'position:absolute; top:24px; right:24px; z-index:2300',
    )
    containerElement.setAttribute('apex-toasts-container', '1')
    return containerElement
  }
  //Return the already existing toasts container DOM
  return toastsContainer[0]
}

const show = (variant, message, showDismissButton, autoHideDuration) => {
  const toastContainer = getToastsContainer()
  const toastChildren = document.querySelectorAll('[apex-toast-index]')
  const lastNode = toastChildren?.[0]

  const containerDomNode = document.createElement('div')
  containerDomNode.setAttribute(
    'apex-toast-index',
    'toast-'.concat(toastChildren.length.toString()),
  )

  if (lastNode) {
    //Attach the new toast before the last one
    toastContainer.insertBefore(containerDomNode, lastNode)
  } else {
    toastContainer.appendChild(containerDomNode)
    //Append the toasts container to document body if no toasts exists
    document.body.appendChild(toastContainer)
  }

  render(
    <Toast
      variant={variant}
      message={message}
      showDismissButton={showDismissButton}
      autoHideDuration={autoHideDuration}
    />,
    containerDomNode,
  )
}

export const apexToast = {
  success: ({ message, showDismissButton, autoHideDuration }) => {
    show(SUCCESS, message, showDismissButton, autoHideDuration)
  },
  error: ({ message, showDismissButton, autoHideDuration }) => {
    show(ERROR, message, showDismissButton, autoHideDuration)
  },

  info: ({ message, showDismissButton, autoHideDuration }) => {
    show(INFO, message, showDismissButton, autoHideDuration)
  },
  warning: ({ message, showDismissButton, autoHideDuration }) => {
    show(WARNING, message, showDismissButton, autoHideDuration)
  },
}

export default apexToast
